AjaxPromise = require 'network/ajax-promise'
AskAnAdminComponent = require 'views/organization/ask-an-admin-component'
Auth = require 'db/auth'
Controller = require 'controller'
CreditCardFormComponent = require 'views/billing/credit-card-form-component'
ModelLoader = require 'db/model-loader'
OrgFeatures = require 'data/org-features'
PaidAccount = require 'network/paid-account'
PaidProductBannerComponent = require 'views/ads/paid-product-banner-component'
React = require 'react'
ReactDOM = require 'react-dom'
f = require 'effing'
recup = require 'recup'
ldclient = require 'lib/ldclient'
{ getOrgBoardLimits } = require 'views/board-create/helpers'

module.exports = class SignupComponent extends React.Component
  displayName: 'SignupComponent'

  constructor: (props) ->
    super(props)

    { yearly, monthly, billingStrategy } = OrgFeatures.currentPriceObjectForModel(@props.model)
    @state =
      defaultProduct: yearly.productNumber
      monthlyProduct: monthly
      yearlyProduct: yearly
      billingStrategy: billingStrategy

    ldclient.on 'ready', @updateProduct
    ldclient.on 'change:bc.multiboard_guests', @updateProduct

  updateProduct: =>
    { yearly, monthly, billingStrategy } = OrgFeatures.currentPriceObjectForModel(@props.model)
    @setState
      defaultProduct: yearly.productNumber
      monthlyProduct: monthly
      yearlyProduct: yearly
      billingStrategy: billingStrategy


  render: recup.renderable ->
    { model, options, getOrgBoardLimits } = @props
    recup.div =>
      if !model.isFeatureEnabled('plugins')
        recup.createElement PaidProductBannerComponent,
          stringsKey: 'business-class'
          subtitleCount: 1
          infoUrl: '/business-class'
          epilogueCount: 0
          icon: 'business-class'
          getOrgBoardLimits: getOrgBoardLimits


      if model.owned()
        recup.div '.billing', =>
          recup.createElement CreditCardFormComponent,
            defaultProduct: @state.defaultProduct
            monthlyProduct: @state.monthlyProduct
            yearlyProduct: @state.yearlyProduct
            billingStrategy: @state.billingStrategy
            onSubmit: f(PaidAccount, 'createAccount', model)
            doPoll: f(AjaxPromise, url: "#{ model.urlRoot }/#{ model.id }?paid_account=true")
            buttonKey: 'start-business-class'
            productName: "Business Class"
            extraData:
              billingContactFullName: model.get('paidAccount')?.contactFullName ? Auth.me().get('fullName')
              billingContactEmail: model.get('paidAccount')?.contactEmail ? Auth.me().get('email')
              billingContactLocale: model.get('paidAccount')?.contactLocale ? Auth.me().getPref('locale')
            didntGetAuthStatus: =>
              ModelLoader.loadOrganizationData model.get('name')
              .done()
            didGetAuthStatus: =>
              if (returnUrl = options.urlOptions?.returnUrl)?
                ModelLoader.loadOrganizationPaidAccount(model.id)
                .then =>
                  Controller.navigate(returnUrl, { trigger: true })
              else
                Controller.organizationBoardsView(model.get('name'), model.id)

      else if !model.isFeatureEnabled('plugins')
        recup.createElement AskAnAdminComponent,
          admins:
            model.memberList.chain()
            .filter (member) =>
              model.ownedByMember(member)
            .map (member) =>
              avatarHash: member.get('avatarHash')
              fullName: member.get('fullName')
              username: member.get('username')
            .value()



// WEBPACK FOOTER //
// ./app/scripts/views/organization/signup-component.coffee